var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 34,
    viewBox: "0 0 42 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 16.6063V17.2783L40.3947 19.313C40.0307 19.7703 39.368 19.8357 38.92 19.4623L21.448 4.893C21.1867 4.669 20.804 4.669 20.5427 4.893L3.024 19.5183C2.62267 19.8543 2.03467 19.789 1.708 19.3877L0 17.2317V16.6157L19.1147 0.693C20.2253 -0.231 21.8307 -0.231 22.932 0.693L28.84 5.649C29.0547 5.82633 29.3907 5.677 29.3907 5.38767L29.372 0.935667C29.3627 0.497 29.7173 0.142333 30.156 0.133C31.9947 0.0863334 33.7307 0.0956665 35.3547 0.142333C35.812 0.161 36.0453 0.450334 36.0453 1.01033C36.0267 4.249 36.036 7.64633 36.0733 11.1837C36.0827 11.4823 36.2133 11.7623 36.4373 11.949L42 16.6063Z",
    fill: "#E0861B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3227 23.7931C24.3227 23.6531 24.2014 23.5317 24.052 23.5317H17.948C17.7987 23.5317 17.6774 23.6531 17.6774 23.7931V32.8464C17.6774 33.1824 17.3974 33.4624 17.0614 33.4624L7.94271 33.4531C6.62671 33.4531 5.96405 32.7904 5.96405 31.4744L5.95471 19.7424C5.95471 19.4064 6.10405 19.0891 6.36538 18.8744L20.6454 7.09573C20.8787 6.89973 21.1214 6.89973 21.364 7.09573L35.5787 18.8184C35.8774 19.0704 36.0547 19.4437 36.0547 19.8357L36.036 31.9504C36.036 32.7811 35.3547 33.4531 34.524 33.4531H24.8174C24.4814 33.4531 24.3134 33.2851 24.3134 32.9584L24.3227 23.7931Z",
    fill: "#E0861B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.88770baf0fc8d6bd24d79a83040a55f6.svg";
export { ForwardRef as ReactComponent };